(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pomlie-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-pomlie-popup]');

    if (!dialog) return;

    const formElement = dialog.querySelector('form');
    const formState = dialog.querySelector('[data-pomlie-popup-form]');
    const closeButtons = dialog.querySelectorAll('[data-pomlie-popup-close]');
    const email = dialog.querySelector('[data-pomlie-email]');
    const consent = dialog.querySelector('[data-pomlie-consent]');
    const consentError = dialog.querySelector('[data-pomlie-consent-error]');
    const submit = dialog.querySelector('[type="submit"]');
    const copyButton = dialog.querySelector('[data-copy-code]');
    const copyStatus = dialog.querySelector('[data-copy-status]');
    const closedKey = 'pomlie_newsletter_popup_closed_until';
    const subscribedKey = 'pomlie_newsletter_popup_subscribed';
    const oneDay = 24 * 60 * 60 * 1000;

    const readStorage = (key) => {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const writeStorage = (key, value) => {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        return null;
      }

      return value;
    };

    const isDesignMode = Boolean(window.Shopify && Shopify.designMode);
    const isSuccess = formState && formState.dataset.success === 'true';
    const hasServerError = formState && formState.dataset.error === 'true';

    const markClosed = () => {
      if (isSuccess) {
        writeStorage(subscribedKey, '1');
        return;
      }

      writeStorage(closedKey, String(Date.now() + oneDay));
    };

    const close = () => {
      markClosed();

      if (dialog.open && typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    const open = () => {
      if (dialog.open) return;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      window.requestAnimationFrame(() => {
        if (isSuccess) {
          copyButton?.focus();
        } else {
          email?.focus();
        }
      });
    };

    const shouldShow = () => {
      if (isDesignMode || isSuccess || hasServerError) return true;
      if (readStorage(subscribedKey) === '1') return false;

      const closedUntil = Number(readStorage(closedKey) || 0);
      return !closedUntil || Date.now() >= closedUntil;
    };

    closeButtons.forEach((button) => button.addEventListener('click', close));

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    consent?.addEventListener('change', () => {
      consentError.hidden = true;
      consent.removeAttribute('aria-invalid');
    });

    email?.addEventListener('input', () => {
      email.setCustomValidity('');
    });

    email?.addEventListener('invalid', () => {
      if (email.validity.typeMismatch) {
        email.setCustomValidity(email.dataset.invalidMessage || '');
      }
    });

    formElement?.addEventListener('invalid', (event) => {
      if (event.target === consent) {
        consentError.hidden = false;
        consent.setAttribute('aria-invalid', 'true');
      }
    }, true);

    formElement?.addEventListener('submit', (event) => {
      if (consent && !consent.checked) {
        event.preventDefault();
        consentError.hidden = false;
        consent.setAttribute('aria-invalid', 'true');
        consent.focus();
        return;
      }

      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }
    });

    copyButton?.addEventListener('click', async () => {
      const code = copyButton.dataset.copyCode;
      let copied = false;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        } else {
          const temporaryInput = document.createElement('textarea');
          temporaryInput.value = code;
          temporaryInput.setAttribute('readonly', '');
          temporaryInput.style.position = 'fixed';
          temporaryInput.style.opacity = '0';
          document.body.appendChild(temporaryInput);
          temporaryInput.select();
          copied = document.execCommand('copy');
          temporaryInput.remove();
        }
      } catch (error) {
        copied = false;
      }

      copyStatus.hidden = false;
      copyStatus.textContent = copied ? copyButton.dataset.copiedLabel : copyButton.dataset.copyError;
      copyButton.textContent = copied ? copyButton.dataset.copiedLabel : copyButton.dataset.copyLabel;
    });

    if (shouldShow()) {
      window.setTimeout(open, isSuccess || hasServerError || isDesignMode ? 250 : 7000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
